import { render, staticRenderFns } from "./GerenciarBancoHorasPage.vue?vue&type=template&id=6866ae98"
import script from "./GerenciarBancoHorasPage.vue?vue&type=script&lang=js"
export * from "./GerenciarBancoHorasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports